var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconShowPasswordOn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .pass_on_a {\n                fill: none !important;\n            }\n\n            .pass_on_b {\n                fill: #fff;\n                fill-rule: evenodd;\n            }\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "pass_on_a",
    width: 32,
    height: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "pass_on_b",
    d: "M85.5,1567.8c-6.349,0-9.351-4.8-10.342-6.844.991-2.062,3.993-6.844,10.342-6.844s9.351,4.781,10.342,6.844C94.851,1563,91.849,1567.8,85.5,1567.8Zm-12.349-6.172a1.606,1.606,0,0,1,0-1.359c.962-2.078,4.474-8.266,12.349-8.266s11.387,6.188,12.349,8.266a1.606,1.606,0,0,1,0,1.359c-.962,2.094-4.474,8.281-12.349,8.281S74.113,1563.719,73.151,1561.625Zm16.561-.672a4.212,4.212,0,1,1-4.212-4.219A4.2,4.2,0,0,1,89.712,1560.953Z",
    transform: "translate(-69.5 -1545)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconShowPasswordOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_show_password_on.d7e93a6600b4d7b22be2cf2700eabf06.svg";